import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex, MainActionButton } from '../../../ui';
//////////////////////////////////////////////////

const whiteColor = G.getTheme('colors.white');

const renderEndIcon = ({ itemList, isReport, singleItem, withoutAddition }) => {
  if (R.or(G.isTrue(isReport), withoutAddition)) return null;

  if (R.or(R.isNil(singleItem), R.and(G.isTrue(singleItem), G.isNilOrEmpty(itemList)))) {
    const icon = I.plusRound(G.getTheme('icons.iconColorWhite'));

    return icon;
  }

  return null;
};

export const FormGroupTitle = (props) => {
  const {
    report,
    itemList,
    isReport,
    groupName,
    singleItem,
    noExportable,
    isReadOnlyMode,
    columnSettings,
    withoutAddition,
    isOpened = true,
    formGroupTitleArr,
    withoutTitlePanel,
    primaryObjectGuid,
    tableTitleFilters,
    handleExportReport,
    primaryObjectGuidKey,
    leftTitleComponentWidth,
    handleCreateOrUpdateItem,
    handleToggleFormGroupTable,
    AdditionalFormGroupTitleComponent,
  } = props;

  const text = G.getWindowLocale(...G.ifElse(G.isNotNilAndNotEmpty(formGroupTitleArr), formGroupTitleArr, []));

  return (
    <Flex
      pl={15}
      pr={16}
      minHeight={30}
      bg={G.getTheme('colors.mainBlue')}
    >
      <Flex width={leftTitleComponentWidth || 'max-content'}>
        <Box
          px='5px'
          color={whiteColor}
          width='max-content'
          whiteSpace='nowrap'
        >
          {text}
        </Box>
        <Box mr='5px' cursor='pointer' onClick={handleCreateOrUpdateItem}>
          {renderEndIcon({
            itemList,
            isReport,
            singleItem,
            withoutAddition: R.or(isReadOnlyMode, withoutAddition),
          })}
        </Box>
        {
          R.and(isOpened, G.isNotNil(AdditionalFormGroupTitleComponent)) &&
          <AdditionalFormGroupTitleComponent {...props} />
        }
        {
          R.not(noExportable) && withoutTitlePanel &&
          <MainActionButton
            ml={20}
            bg='unset'
            p='2px 8px'
            height={22}
            fontSize={12}
            color={whiteColor}
            borderColor={whiteColor}
            onClick={() => {
              const { type, fields } = report;

              handleExportReport({
                name: type,
                fileType: 'xlsx',
                queryParams: { [primaryObjectGuidKey]: primaryObjectGuid },
                searchCriteria: G.isNotNilAndNotEmpty(tableTitleFilters) ? R.values(tableTitleFilters) : [],
                fields: R.map(
                  ({ name, sequence }) => ({
                    name,
                    sequence,
                    displayName: G.getWindowLocale(R.path([name, GC.FIELD_NAME], columnSettings), name),
                  }),
                  fields,
                ),
              });
            }}
          >
            {G.getWindowLocale('actions:export-exl')}
          </MainActionButton>
        }
      </Flex>
      <Box width='100%' onClick={() => handleToggleFormGroupTable(groupName)}>
        <Box ml='auto' width='max-content' transform={G.ifElse(isOpened, 'rotate(180deg)')}>
          {I.arrowDownSimple(whiteColor)}
        </Box>
      </Box>
    </Flex>
  );
};
